﻿import document from 'document';

export const cookieBanner = () => {
    const selectors = {
        root: '.js-cookie-banner',
        closeBtn: '.js-close-and-store-cookie',
        cookieBannerVisible: 'cookie-banner--visible'
    };

    const config = {
        cookieName: 'cookiePolicyAccepted'
    };

    const _createCookie = (name, value, days) => {
        var expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toGMTString();
        }
        else {
            expires = '';
        }
        document.cookie = name + '=' + value + expires + '; path=/';
    };

    const _readCookie = (name) => {
        var cookieName = name + '=';
        var storedCookies = document.cookie.split(';');
        var filteredCookie = storedCookies.filter(function (cookie) {
            if (cookie.indexOf(cookieName) != -1) {
                return cookieName;
            }
        });
        return filteredCookie;
    };

    const _showCookieBanner = (el) => {
        el.classList.add(selectors.cookieBannerVisible);
    };

    const _hideCookieBanner = (el) => {
        el.closest(selectors.root).classList.remove(selectors.cookieBannerVisible);
    };

    const _bindEvents = () => {
        const button = document.querySelectorAll(selectors.closeBtn)[0];
        button.addEventListener('click', (e) => {
            e.preventDefault();
            _createCookie(config.cookieName, 'true', 30);
            _hideCookieBanner(e.currentTarget);
        });
    };

    const init = component => {
        if (!_readCookie(config.cookieName).length) {
            _showCookieBanner(component);
            _bindEvents();
        }
    };

    return {
        init: init,
        selector: selectors.root
    };
};